import { useLoginStates } from '@/hooks';

export const useSubmitConfirmationCopies = () => {
  const { isLoggedIn } = useLoginStates();

  return isLoggedIn
    ? {
        header: 'JOBS_POSTING_EASY_APPLY_FORM_CONFIRMATION_HEADER',
        body: 'JOBS_INSTANT_APPLY_FORM_CONFIRMATION_BODY',
        cta: 'JOBS_POSTING_EASY_APPLY_FORM_CONFIRMATION_CTA',
      }
    : {
        header: 'JOBS_POSTING_APPLY_FORM_LO_CONFIRMATION_HEADLINE',
        body: 'JOBS_POSTING_APPLY_FORM_LO_CONFIRMATION_BODY',
        cta: 'JOBS_POSTING_EASY_APPLY_FORM_CONFIRMATION_CTA',
        register: 'JOBS_POSTING_APPLY_FORM_LO_CONFIRMATION_REGISTER',
      };
};
